const RETURN_PAGE_KEY = 'quecai-login-source-page'

// 记录实际离开的详情页，而不是登录完成后的业务目标。
export function rememberLoginSource() {
  try {
    sessionStorage.setItem(RETURN_PAGE_KEY, window.location.href)
  } catch {
    // 禁用存储时仍允许登录。
  }
}

export function clearLoginSource() {
  try {
    sessionStorage.removeItem(RETURN_PAGE_KEY)
  } catch {
    // 不影响页面使用。
  }
}

export function installLoginBackRecovery() {
  window.addEventListener('pageshow', (event) => {
    let source
    try {
      source = sessionStorage.getItem(RETURN_PAGE_KEY)
    } catch {
      return
    }
    if (source !== window.location.href) return
    // 先消费标记，保证刷新后不会循环。正常登录回调的 replace 不属于后退。
    clearLoginSource()
    const navigation = performance.getEntriesByType('navigation')[0]
    if (event.persisted || navigation?.type === 'back_forward') {
      // 不复用登录前缓存的组件导入失败状态，保留原详情的 query 和 hash。
      window.location.reload()
    }
  })
}